import { ReactNode } from "react";

interface DesktopViewToggleButtonProps {
  isOpen: boolean;
  onClick: () => void;
  children: ReactNode;
  title?: string;
}

export function DesktopViewToggleButton({ isOpen, onClick, children, title = "Open nutrition facts" }: DesktopViewToggleButtonProps) {
  if (isOpen) return null;

  return (
    <button
      onClick={onClick}
      className="hidden lg:block fixed right-4 top-4 z-30 border border-secondary text-secondary rounded-full p-2 transition-all duration-300 hover:bg-secondary/5"
      title={title}
    >
      {children}
    </button>
  );
}
